"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Calendar } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import { useParams } from "next/navigation";
import Link from "next/link";
import { Locale } from "@/lib/i18n/config";
import { businessData } from "@/lib/business-data";

export default function MobileCTABar() {
  const { t, locale } = useTranslation("common");
  const params = useParams();
  const currentLocale = (params?.locale as Locale) || locale;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100 }}
          animate={{ y: 0 }}
          exit={{ y: 100 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-navy border-t border-gold/20 safe-area-bottom"
        >
          <div className="flex items-stretch">
            <a
              href={`tel:${businessData.phone}`}
              className="flex-1 flex items-center justify-center gap-2 py-3 text-white hover:bg-navy-800 transition-colors"
            >
              <Phone className="h-4 w-4 text-gold" />
              <span className="text-sm font-medium">
                {t("mobileCta.call") || "Call Now"}
              </span>
            </a>
            <div className="w-px bg-gold/20" />
            <Link
              href={`/${currentLocale}/book-appointment`}
              className="flex-1 flex items-center justify-center gap-2 py-3 bg-gold text-navy hover:bg-gold-600 transition-colors"
            >
              <Calendar className="h-4 w-4" />
              <span className="text-sm font-bold">
                {t("mobileCta.book") || "Book Now"}
              </span>
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
